import { DocumentStatus } from '@kanbu/schema/enums';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button } from '@utima/ui';
import { memo } from 'react';

import { SimpleTooltip } from '@/components';
import { useDocumentMutation } from '@/features/documents';

export type RetryFailedButtonProps = {
  chat: {
    id: string;
    parsingErrorDocumentsCount?: number | string | null;
    embeddingErrorDocumentsCount?: number | string | null;
  };
};

export const RetryFailedButton = memo(function RetryFailedButton({
  chat,
}: RetryFailedButtonProps) {
  const { refreshAll } = useDocumentMutation();

  const handleRetry = async () => {
    await refreshAll.mutateAsync({
      chatId: chat.id,
      statuses: [DocumentStatus.EmbeddingError, DocumentStatus.ParsingError],
    });
  };

  if (
    Number(chat.parsingErrorDocumentsCount) === 0 &&
    Number(chat.embeddingErrorDocumentsCount) === 0
  ) {
    return null;
  }

  return (
    <SimpleTooltip title={t`Retry failed documents`}>
      <Button
        data-cta='admin-retry-failed-button'
        size='sm'
        variant='danger'
        loading={refreshAll.isPending}
        disabled={refreshAll.isPending}
        onClick={handleRetry}
      >
        <Trans>Retry Failed</Trans>
      </Button>
    </SimpleTooltip>
  );
});
